import { useEffect, useState } from "react";
import { publicApi, BACKEND_URL } from "@/lib/api";

let cache = null;
let pending = null;
const subs = new Set();
const abs = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);

export const refreshBranding = async () => {
  const r = await publicApi.get("/branding");
  cache = { icon_url: abs(r.data.icon_url), mascot_url: abs(r.data.mascot_url), base_mascot_url: abs(r.data.base_mascot_url), theme: r.data.theme };
  subs.forEach((f) => f(cache));
  return cache;
};

export function useBranding() {
  const [b, setB] = useState(cache || {});
  useEffect(() => {
    subs.add(setB);
    if (!cache && !pending) pending = refreshBranding().catch(() => {});
    return () => subs.delete(setB);
  }, []);
  return b;
}

export const applyThemeColors = (colors) => {
  if (!colors) return;
  const root = document.documentElement.style;
  Object.entries(colors).forEach(([k, v]) => root.setProperty(`--tp-${k}`, v));
};

export function BrandingEffects() {
  const { icon_url, theme } = useBranding();
  useEffect(() => { applyThemeColors(theme?.colors); }, [theme]);
  useEffect(() => {
    document.title = "TP Quiz — Learning that rolls with you";
    if (!icon_url) return;
    let link = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = icon_url;
  }, [icon_url]);
  return null;
}
